var deviceTypes = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop'
};
var isDeviceType = function isDeviceType(_ref, type) {
  var external = _ref.external;
  return (external === null || external === void 0 ? void 0 : external.deviceType) === type;
};
export var isMobileDevice = function isMobileDevice(state) {
  return isDeviceType(state, deviceTypes.MOBILE);
};
export var isTabletDevice = function isTabletDevice(state) {
  return isDeviceType(state, deviceTypes.TABLET);
};
export var isDesktopDevice = function isDesktopDevice(state) {
  return isDeviceType(state, deviceTypes.DESKTOP);
};
export var isIE = function isIE() {
  if (typeof window === 'undefined') return false;
  return /(MSIE |Edge|Trident)/.test(window.navigator.userAgent);
};
export var isSSR = function isSSR() {
  return typeof window === 'undefined';
};